import React, {FC} from 'react'

interface TabNavigationButtonsProps {
  onBack?: () => void
  onNext?: () => void
  isSubmit?: boolean
  backLabel?: string
  nextLabel?: string
}

export const TabNavigationButtons: FC<TabNavigationButtonsProps> = ({
  onBack,
  onNext,
  isSubmit = false,
  backLabel = '« Geri',
  nextLabel = 'Devam »',
}) => {
  const hasBack = !!onBack
  const hasNext = !!onNext || isSubmit

  return (
    <div className={`d-flex ${hasBack ? 'justify-content-between' : 'justify-content-end'} mt-4`}>
      {hasBack && (
        <button type='button' className='btn btn-light' onClick={onBack}>
          {backLabel}
        </button>
      )}
      {isSubmit ? (
        <button type='submit' className='btn btn-success'>
          {nextLabel}
        </button>
      ) : hasNext ? (
        <button type='button' className='btn btn-primary' onClick={onNext}>
          {nextLabel}
        </button>
      ) : null}
    </div>
  )
}
